import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { actionCreators as toastAlertsCreators } from 'react/api/actions/toastAlerts';

import { connect } from 'react-redux';

function secondaryToast({
  toastId,
  type,
  title,
  description,
  removeToast,
  ...rest
}) {
  const toastContainerRef = useRef(null);
  const mainTimerRef = useRef(null);
  const secondaryTimerRef = useRef(null);

  function clearTimeouts() {
    clearTimeout(mainTimerRef.current);
    clearTimeout(secondaryTimerRef.current);
  }

  function removeThisToast() {
    removeToast({ id: toastId });
  }

  function initTimeout() {
    if (mainTimerRef.current) {
      clearTimeouts();

      toastContainerRef.current.classList.remove('animation_trigger');
    }

    mainTimerRef.current = setTimeout(() => {
      toastContainerRef.current.classList.add('animation_trigger');

      secondaryTimerRef.current = setTimeout(() => {
        removeThisToast();
      }, 1000);
    }, 7000);
  }

  useEffect(() => {
    initTimeout();

    return () => {
      clearTimeouts();
    };
  }, []);

  return (
    <div
      id="toast-container"
      className={`secondary ${type}`}
      ref={toastContainerRef}
      onMouseMove={initTimeout}
      {...rest}
    >
      <div className="toast-icon">
        <span className={`${type}-icon`} />
      </div>
      <div className="toast-content">
        <div className="toast-header">
          <h4>{title}</h4>
          <span
            className="close-icon"
            onClick={removeThisToast}
            alt="Close Icon"
          />
        </div>
        <p>{description}</p>
      </div>
    </div>
  );
}

secondaryToast.defaultProps = {
  type: 'success'
};

secondaryToast.propTypes = {
  toastId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  removeToast: PropTypes.func.isRequired,
  type: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

const mapDispatchToProps = {
  removeToast: toastAlertsCreators.removeToast
};

export default connect(null, mapDispatchToProps)(secondaryToast);
